/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Your_TimeInputs */

const th_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} ตามเวลาของคุณ`)
};

const en_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} your time`)
};

const ja_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time}（あなたの現地時刻）`)
};

const zh_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你所在时区的 ${i?.time}`)
};

const es_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} en tu hora local`)
};

const pt_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} no seu horário`)
};

const id_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} waktu Anda`)
};

const fr_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} à votre heure`)
};

const tl_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} sa oras mo`)
};

const vi_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} theo giờ của bạn`)
};

const ko_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`현지 시각으로 ${i?.time}`)
};

const de_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} deiner Zeit`)
};

const ru_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} по вашему времени`)
};

const tr_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sizin saatinizle ${i?.time}`)
};

const it_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} ora tua`)
};

const pl_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} twojego czasu`)
};

const uk_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} за вашим часом`)
};

const hi_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपके समय के अनुसार ${i?.time}`)
};

const ar_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} بتوقيتك`)
};

const ms_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} waktu anda`)
};

const bn_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আপনার সময়ে ${i?.time}`)
};

const zh_tw2_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你所在時區的 ${i?.time}`)
};

const zh_hk2_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你所在時區的 ${i?.time}`)
};

const ur_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آپ کے وقت کے مطابق ${i?.time}`)
};

const fa_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} به وقت شما`)
};

const sw_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} kwa saa zako`)
};

const nl_your_time = /** @type {(inputs: Your_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} bij jou`)
};

/**
* | output |
* | --- |
* | "{time} your time" |
*
* @param {Your_TimeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_time = /** @type {((inputs: Your_TimeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_TimeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_time(inputs)
	if (locale === "ja") return ja_your_time(inputs)
	if (locale === "zh") return zh_your_time(inputs)
	if (locale === "es") return es_your_time(inputs)
	if (locale === "pt") return pt_your_time(inputs)
	if (locale === "id") return id_your_time(inputs)
	if (locale === "fr") return fr_your_time(inputs)
	if (locale === "tl") return tl_your_time(inputs)
	if (locale === "vi") return vi_your_time(inputs)
	if (locale === "ko") return ko_your_time(inputs)
	if (locale === "de") return de_your_time(inputs)
	if (locale === "ru") return ru_your_time(inputs)
	if (locale === "tr") return tr_your_time(inputs)
	if (locale === "it") return it_your_time(inputs)
	if (locale === "pl") return pl_your_time(inputs)
	if (locale === "uk") return uk_your_time(inputs)
	if (locale === "hi") return hi_your_time(inputs)
	if (locale === "ar") return ar_your_time(inputs)
	if (locale === "ms") return ms_your_time(inputs)
	if (locale === "bn") return bn_your_time(inputs)
	if (locale === "zh-TW") return zh_tw2_your_time(inputs)
	if (locale === "zh-HK") return zh_hk2_your_time(inputs)
	if (locale === "ur") return ur_your_time(inputs)
	if (locale === "fa") return fa_your_time(inputs)
	if (locale === "sw") return sw_your_time(inputs)
	if (locale === "nl") return nl_your_time(inputs)
	return en_your_time(inputs)
});